import { Typography } from '@snack-uikit/typography';
import { useAnalytics } from 'src/hooks/useAnalytics';

import s from './FooterModalButton.module.scss';

export function FooterModalButton({
  id,
  text,
  onClick,
}: {
  id: string;
  text: string;
  onClick: () => void;
}) {
  const { clickAnalytics } = useAnalytics();

  return (
    <div
      data-qa={id}
      className={s.footerLink}
      onClick={() => {
        onClick();
        clickAnalytics({
          action: 'click',
          clickZone: 'footer',
          clickElement: 'textclick',
          clickContent: text,
          uniqueId: 'footer-consultation',
          transitionType: 'inside-link',
          clickZoneCategory: 'site-footer',
        });
      }}
    >
      <Typography
        className={s.footerLinkText}
        family="sans"
        purpose="body"
        size="m"
      >
        {text}
      </Typography>
    </div>
  );
}
